import '../assets/NcActionText-YljCzD9Q.css';
import { A as s } from "../chunks/actionText-jLsEBszD.mjs";
import { n as a } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const e = {
  name: "NcActionText",
  mixins: [s],
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: !1
    }
  }
};
var i = function() {
  var t = this, n = t._self._c;
  return n("li", { staticClass: "action", attrs: { role: t.isInSemanticMenu && "presentation" } }, [n("span", { staticClass: "action-text", on: { click: t.onClick } }, [t._t("icon", function() {
    return [t.icon !== "" ? n("span", { staticClass: "action-text__icon", class: [t.isIconUrl ? "action-text__icon--url" : t.icon], style: { backgroundImage: t.isIconUrl ? "url(".concat(t.icon, ")") : null }, attrs: { "aria-hidden": "true" } }) : t._e()];
  }), t.name ? n("span", { staticClass: "action-text__longtext-wrapper" }, [n("strong", { staticClass: "action-text__name" }, [t._v(" " + t._s(t.name) + " ")]), n("br"), n("span", { staticClass: "action-text__longtext", domProps: { textContent: t._s(t.text) } })]) : t.isLongText ? n("span", { staticClass: "action-text__longtext", domProps: { textContent: t._s(t.text) } }) : n("span", { staticClass: "action-text__text" }, [t._v(t._s(t.text))]), t._e()], 2)]);
}, c = [], o = /* @__PURE__ */ a(
  e,
  i,
  c,
  !1,
  null,
  "34d9a49c",
  null,
  null
);
const x = o.exports;
export {
  x as default
};
